export default __webpack_public_path__ + "locales/zh-CN/WebPlugins.json?hash=59709d6b72f285080588bd65d1aff2fc";